//加载电站设备类型时是否显示加载中...
export const ALARM_DEVICEANALYSE_DEVICE_TYPES_LOAD='alarm/device/type/list/FETCH_DEVICE_TYPES_LOAD';
//异步加载电站设备类型信息
export const ALARM_FETCH_DEVICEANALYSE_DEVICE_TYPES='alarm/device/type/list/FETCH_DEVICE_TYPES';
//处理电站设备类型信息
export const ALARM_DEVICEANALYSE_DEVICE_TYPES='alarm/device/type/list/DEVICE_TYPES';
//选中的设备类型信息
export const ALARM_DEVICEANALYSE_DEVICE_TYPE_ID='alarm/device/type/list/DEVICE_TYPE_ID';